new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement && formButton) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    const icon = formButton.querySelector('i');
                    const originalText = formButton.textContent;

                    formButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        navigator.clipboard.writeText(newValue).then(() => {

                            // altera texto mantendo o ícone
                            if (icon) {
                                formButton.innerHTML = 'Copiado!';
                            } else {
                                formButton.textContent = 'Copiado!';
                            }

                            // volta ao original após 2s
                            setTimeout(() => {
                                if (icon) {
                                    formButton.innerHTML = icon.outerHTML + ' ' + originalText.trim();
                                } else {
                                    formButton.textContent = originalText;
                                }
                            }, 2000);

                        }).catch(err => {
                            console.error('Erro ao copiar: ', err);
                        });
                    });
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {

    var bannerHomeFull = $('.banner-home');
    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 4000,
        dots: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 2000,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    // Em telas pequenas troca o video desktop pelo video mobile (o atributo
    // media do <source> nao e suportado dentro de <video>)
    function setBannerVideoSource() {
        var isMobile = window.matchMedia('(max-width: 768px)').matches;

        $('.banner-home video[data-video-desktop]').each(function () {
            var desktop = this.getAttribute('data-video-desktop');
            var mobile = this.getAttribute('data-video-mobile') || desktop;
            var src = isMobile ? mobile : desktop;

            if (src && this.getAttribute('src') !== src) {
                this.setAttribute('src', src);
                this.load();
            }
        });
    }

    // O slick remove e reinsere os slides no DOM ao montar o carrossel (e clona
    // os slides quando infinite: true). Ao sair do documento o browser pausa o
    // <video> e o atributo autoplay nao dispara de novo, entao damos play na mao
    function playBannerVideos() {
        $('.banner-home video').each(function () {
            this.muted = true;

            var playPromise = this.play();
            if (playPromise && playPromise.catch) {
                playPromise.catch(function () {});
            }
        });
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });

        // o pause do browser e agendado para depois da remocao do DOM,
        // por isso o play precisa acontecer no proximo tick
        setTimeout(playBannerVideos, 0);
    });

    bannerHomeFull.on('afterChange', playBannerVideos);

    setBannerVideoSource();
    initBannerHome(bannerHomeFull);

    $(window).on('resize', function () {
        setBannerVideoSource();
        playBannerVideos();
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        $('.faixa-comunicado-content').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

     waitForElementToExist('#js-categories-list').then(element => {
        $('#js-categories-list').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    });

     waitForElementToExist('.banner-instagram-luvas').then(element => {
        $('.banner-instagram-slick').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3500,
            infinite: true,
            arrows: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

     waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if (firstCarrousel) {
            $('#product_list').slick({
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: true,
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list2');
        if (firstCarrousel) {
            $('#product_list2').slick({
                arrows: true,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 1000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    },
                ]
            });

            $('#product_list2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function (element) {
                        setTimeout(function () {
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.rotation-vitrine').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        arrows: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        arrows: true,
                        dots: false,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: true,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll:1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        arrows: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        arrows: true,
                        dots: false
                    }
                }
            ]
        });
        $('#carrousel-product-list3').slick({
            arrows: true,
            dots: true,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        arrows: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        arrows: true,
                        dots: false
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);
    
            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
    
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
    
                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function(i, c){
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);
    
                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                        '#carrousel-product-list3'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');
                
                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }
    
                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });
    
                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.banner-product').then(element => {
        $('#product-banner').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });

        $('#product-banner').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('#banner-product-2').then(element => {
        $('#product-banner2').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });

        $('#product-banner2').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

});